import DjangoContextsMiddleware from "../../../../contents/docs/libraries/python/_snippets/django-context-middleware.mdx";
import * as React from 'react';
export default {
  DjangoContextsMiddleware,
  React
};